export enum PromotionDiscountLimitType {
    Dollar = "Dollar",
    Quantity = "Quantity",
}
